import React from 'react'
import Layout from '../components/layout'

import Header from '../components/Header'
import Main from '../components/Main'
import Footer from '../components/Footer'

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <div className="body">
      <a className="skip-link" href="#expertise">
        Skip to content
      </a>
      <div id="wrapper">
        <Header />
        <Main />
        <Footer />
      </div>
      <div id="bg" />
    </div>
  </Layout>
)

export default IndexPage
